// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".with-mobile[data-v-5d35083a] {\n  width: 190px !important;\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n}", ""]);
// Exports
module.exports = exports;
